import { I18n } from '@calendly/i18n'
import { Group } from '@calendly/ui/components/menu'

import { useGetUserQuery } from 'common'

import AllScope from './all_scope'
import Header from './header'
import Item from './item'

const PrimaryList = ({ shouldRenderUsersAndTeams }) => {
  const { data } = useGetUserQuery()

  return (
    <Group>
      <Header title={I18n.t('publisher.event_types.scope_dropdown.primary')} />
      <Item
        value="my_calendly"
        avatarLetter={data?.avatar_letter}
        avatarUrl={data?.avatar_url}
      >
        {I18n.t('publisher.title.my_calendly')}
      </Item>
      {shouldRenderUsersAndTeams && (
        <AllScope scope="all_users_and_teams" />
      )}
    </Group>
  )
}

export default PrimaryList
